export default {
  path: '/',
  name: 'Home',
  component: () => import('../views/home/Home'),
  meta: {
    breadcrumb: 'global.home',
  },
};
